import styles from "./PaginationBottom.module.scss";

export const PaginationBottom = ({limit, perPage, currentPage, setCurrentPage}) => {
    return (
        <div className={styles['pagination__bottom']}>
            {limit ? Array(Math.ceil(limit / perPage)).fill().map((_, index) => (
                <button className={currentPage == index + 1 ? styles.active : {}} key={index}
                        onClick={() => setCurrentPage(index)}>{index + 1}</button>
            )) : <button className={styles.active}>1</button>}

        </div>
    );
};